export * from '@primeuix/themes/material/iconfield';
export { default } from '@primeuix/themes/material/iconfield';
